import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {Switch} from "../buttons/Swtich";
import {HELP_ADMIN_AND_REGULAR_USERS, LinkToArticle} from "../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';


class UserSecurityInfoClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            userSecurityInfo: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    userSecurityDataURL() {
        return API_URL + 'user/' + this.props.userId + '/access';
    }

    setIsSaving(new_value) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        });
    }

    getUserSecurityData() {
        this.setIsSaving(true);
        new APIClient(this.userSecurityDataURL()).call('GET').then((data) => {
            this.setIsSaving(false);
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    userSecurityInfo: {
                        'userType': data.data['user_type'],
                        // 'canUseMarketingModule': data.data['can_use_marketing_module'],
                        // 'canUseManageAccountsModule': data.data['can_use_manage_accounts_module'],
                        'canUseMarketingModule': true,
                        'canUseManageAccountsModule': false,
                        'moduleMarketingCanAssignClients': data.data['module_marketing_can_assign_clients']
                    }
                });
            }
        })
    }


    componentDidMount() {
        this.getUserSecurityData();
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this.userSecurityDataURL()).call('POST', {
            'user_type': this.state.userSecurityInfo.userType,
            // 'can_use_marketing_module': this.state.userSecurityInfo.canUseMarketingModule,
            // 'can_use_manage_accounts_module': this.state.userSecurityInfo.canUseManageAccountsModule,
            'can_use_marketing_module': true,
            'can_use_manage_accounts_module': false,
            'module_marketing_can_assign_clients': this.state.userSecurityInfo.moduleMarketingCanAssignClients

        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit();
            }
            this.setState({
                userSecurityInfo: {
                    ...this.state.userSecurityInfo,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const switchesNames = ["canUseMarketingModule", "canUseManageAccountsModule", "moduleMarketingCanAssignClients"]
        const value = switchesNames.includes(name) ? target.checked : target.value;

        this.setState({
            userSecurityInfo: {
                ...this.state.userSecurityInfo,
                [name]: value
            }
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('user_security.save_button')}/>;
        }
    }

    renderUserSecurityInfo() {
        const { t } = this.props;
        if (this.state.userSecurityInfo !== null) {
            const result = [
                <div key={"1"} className="box pb-0">
                    <div className="form-row">
                        <label><span title="Este campo es obligatorio">*</span>{t('user_security.user_type_label')}<LinkToArticle article={HELP_ADMIN_AND_REGULAR_USERS} /></label>
                        <select name="userType" onChange={this.handleChange} required="required"
                                value={this.state.userSecurityInfo.userType}>
                            <option value='Admin'>{t('user_security.admin_option')}</option>
                            <option value='Regular'>{t('user_security.regular_option')}</option>
                        </select>
                    </div>
                    {/*202403: Se oculta el modulo de administracion de cuentas*/}
                    {/*<div className="form-row">*/}
                    {/*    <label>Módulo Gestión de cuentas</label>*/}
                    {/*    <Switch onChange={this.handleChange}*/}
                    {/*            checked={this.state.userSecurityInfo.canUseMarketingModule}*/}
                    {/*            name="canUseMarketingModule"*/}
                    {/*            messageToAlertUserIfChecked={null}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/*<div className="form-row">*/}
                    {/*    <label>Módulo Administración de cuentas</label>*/}
                    {/*    <Switch onChange={this.handleChange}*/}
                    {/*            checked={this.state.userSecurityInfo.canUseManageAccountsModule}*/}
                    {/*            name="canUseManageAccountsModule"*/}
                    {/*            messageToAlertUserIfChecked={null}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            ]

            if (this.state.userSecurityInfo.canUseMarketingModule) {
                if(this.state.userSecurityInfo.userType !== "Admin") {
                    result.push(
                        <div key={"2"} className="box pt-0">
                            {/*202403: Se oculta el modulo de administracion de cuentas*/}
                            {/*<div className="form-header" style={{marginBottom: '1.5em'}}>*/}
                            {/*    <h3 className="form-title"><span>Módulo de Gestión de Cuentas</span>*/}
                            {/*    </h3>*/}
                            {/*</div>*/}
                            <div className="form-row" style={{ display: 'flex', alignItems: 'center' }}>
                                <Switch onChange={this.handleChange}
                                        checked={this.state.userSecurityInfo.moduleMarketingCanAssignClients}
                                        name="moduleMarketingCanAssignClients"
                                        messageToAlertUserIfChecked={null}
                                />
                                <label className="ml-2">{t('user_security.can_modify_clients')}</label>
                            </div>
                        </div>
                    );
                }
            }

            return result
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -wide">
                <div key={"1"} className="box">
                    {this.renderUserSecurityInfo()}
                </div>
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export const UserSecurityInfo = withTranslation()(UserSecurityInfoClass);